import { sleep } from 'app-lib/asyncUtils'
import { chainConfigs } from 'bzx-common/src/config/appConfig'
import { ProviderEvents } from 'bzx-common/src/domain/events'
import { ProviderChangedEvent } from 'bzx-common/src/domain/events/providerEvents'
import { RootStore } from 'bzx-common/src/stores'
import { ISpendingApproval } from 'bzx-common/src/stores/SpendingApprovals'
import * as mobx from 'mobx'
import web3Utils from 'web3-utils'

interface IDebugVM {
  inputImpersonate: string
  approvalsPending: boolean
  viewZeroApprovals: boolean
}

export default class DebugVM implements IDebugVM {
  rootStore: RootStore
  inputImpersonate = ''
  approvalsPending = false
  viewZeroApprovals = false

  get inputImpersonateValid() {
    return this.inputImpersonate === '' || web3Utils.isAddress(this.inputImpersonate)
  }

  get spendingApprovals() {
    const { list } = this.rootStore.spendingApprovals
    if (this.viewZeroApprovals) {
      return list
    }
    return list.filter((approval) => approval.amount.gt(0))
  }

  set(prop: keyof IDebugVM, value: any) {
    ;(this[prop] as any) = value
  }

  assign(props: Partial<IDebugVM>) {
    Object.assign(this, props)
  }

  async fetchImpersonatedBalances() {
    const { userWallet, chain } = this.rootStore
    // Get some info about user balances
    if (chain) {
      await userWallet.getNativeTokenBalance()
      await sleep(500)
      userWallet.getBalances(chain.lending.assets)
    }
  }

  setImpersonate(event: any) {
    event.preventDefault()
    const { fulcrumProvider, web3Connection } = this.rootStore
    fulcrumProvider.impersonateAddress = this.inputImpersonate
    web3Connection.assign({ impersonateAddress: this.inputImpersonate })
    fulcrumProvider.emit(
      ProviderEvents.ProviderChanged,
      new ProviderChangedEvent(fulcrumProvider.providerType, fulcrumProvider.web3Wrapper)
    )
    localStorage.setItem('impersonateAddress', this.inputImpersonate)
    this.inputImpersonate = ''
    setTimeout(() => {
      this.fetchImpersonatedBalances()
    }, 0)
  }

  async getSpendingApprovals() {
    const { spendingApprovals, web3Connection } = this.rootStore
    if (!web3Connection.chainId) {
      return
    }
    this.assign({ approvalsPending: true })
    const assets = chainConfigs[web3Connection.chainId].lending.assets
    await spendingApprovals.checkApprovalsOfAllItokens()
    await spendingApprovals.checkApprovals(
      assets,
      chainConfigs[web3Connection.chainId].contracts.bzx
    )
    this.assign({ approvalsPending: false })
  }

  removeApproval(approval: ISpendingApproval) {
    return this.rootStore.spendingApprovals.removeApproval({
      asset: approval.token,
      spender: approval.spender,
    })
  }

  setProtocolVersion(event: React.ChangeEvent<HTMLSelectElement>) {
    const version = Number(event.target.value)
    this.rootStore.settings.setProtocolVersion(version)
  }

  async init() {
    setTimeout(() => {
      if (this.rootStore.web3Connection.walletAddress) {
        this.fetchImpersonatedBalances()
      }
    }, 0)
  }

  constructor({ rootStore }: { rootStore: RootStore }) {
    this.rootStore = rootStore
    mobx.makeAutoObservable(this, undefined, { deep: false, autoBind: true })
    this.init()
  }
}
